module.exports = __webpack_public_path__ + "img/若依.c8bdc16d.jpg";